<template>
  <div>
    <div v-if="!overrideOn">
      <VButton @click="toggleOverride">Override Value</VButton>
    </div>
    <div v-else>
      <input type="number" v-model.lazy.number="value" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import VButton from '../ui/VButton.vue';


export default {
  components: { VButton },
  name: 'OverrideComponentValue',
  watch: {
    overrideOn: {
      immediate: true,
      handler() { this.lastOverrideValue = this.value; }
    }
  },
  data: function() {
    return {
      overrideOn: false,
      updateHack: 0
    }
  },
  computed: {
    ...mapState(['label']),
    ...mapGetters(['data']),
    value: {
      get() {
        this.updateHack; // Remove tech debt
        return this.data[0].value;
      },
      set(value) {
        this.overrideDataValue({newValue: value});
        // TODO: Remove this tech debt
        this.$emit('updateDataVersion');
        this.updateHack++;
      }
    }
  },
  methods: {
    ...mapMutations(['overrideDataValue']),
    toggleOverride() {
      this.overrideOn = !this.overrideOn;
    }
  },
}
</script>

<style scoped>
</style>